import {useLocation} from "react-router-dom";

type useCurrentRouteDef = () => string;

const useCurrentRoute: useCurrentRouteDef = () => {
  const {pathname} = useLocation();

  return pathname.match(/\/$/)
    ? pathname
    : `${pathname}/`;
}

export default useCurrentRoute;
